import { SumamoruPlan } from "./sumamoru-plan-types";

/**
 * スマモルプランにおける付帯サービスの種類
 * 
 * - BenefitOne: ベネフィットワン
 * - OgSecurityService: 駆けつけ
 * - Viewn: ビューン
 * - SmartPhoneInsurance: スマホ保険
 * - WLock: Wロック
 */
export enum SumamoruAdditionalServices {
  BenefitOne = 'BenefitOne',
  OgSecurityService = 'OgSecurityService',
  Viewn = 'Viewn',
  SmartPhoneInsurance = 'SmartPhoneInsurance',
  WLock = 'WLock',
}

export const setAdditonalService = (sumamoruPlan: SumamoruPlan): SumamoruAdditionalServices[] => {
  return sumamoruPlan === SumamoruPlan.OG_Default
    ? [SumamoruAdditionalServices.OgSecurityService, SumamoruAdditionalServices.BenefitOne]
    : sumamoruPlan === SumamoruPlan.OG_Viewn
    ? [SumamoruAdditionalServices.OgSecurityService, SumamoruAdditionalServices.Viewn]
    : sumamoruPlan === SumamoruPlan.OG_WLock
    ? [SumamoruAdditionalServices.OgSecurityService, SumamoruAdditionalServices.WLock]
    : [];
};
